var exports = {
  "CR": "CustomStatusModal.module__modalRoot___SnBSSE",
  "_l": "CustomStatusModal.module__previewSection___SnBSSE",
  "uG": "CustomStatusModal.module__statusInputWrapper___SnBSSE",
  "Dq": "CustomStatusModal.module__characterCount___SnBSSE",
  "DY": "CustomStatusModal.module__emojiTriggerButton___SnBSSE",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___SnBSSE",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___SnBSSE",
  "J7": "CustomStatusModal.module__clearButtonIcon___SnBSSE",
  "qr": "CustomStatusModal.module__footer___SnBSSE",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___SnBSSE",
  "uD": "CustomStatusModal.module__expirationLabel___SnBSSE",
  "S2": "CustomStatusModal.module__expirationSelect___SnBSSE",
};

module.exports = exports;
